import { render, staticRenderFns } from "./LicenciadaTipoModelo.vue?vue&type=template&id=f699f49c&"
import script from "./LicenciadaTipoModelo.vue?vue&type=script&lang=js&"
export * from "./LicenciadaTipoModelo.vue?vue&type=script&lang=js&"
import style0 from "./LicenciadaTipoModelo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports